// extracted by mini-css-extract-plugin
module.exports = {"item":"chip_item__3BIaF commonStyles_typography__2kf2S","button":"chip_button__1UQ1V"};